module.exports = __webpack_public_path__ + "static/media/goat.ee5e1a4a.jpg";